import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { RedtextStoreService } from '../../services/redtext-store.service';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import { SubSink } from 'subsink';
import { RedtextPageService } from '../../services/redtext.service';
import { FlimmoMetaService } from '../../../../core/services/flimmo-meta.service';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay, tap } from 'rxjs/operators';
import { Redtext } from '../../../../generated-api';
import {
  onResizeSlideshows,
} from 'src/app/core/helpers/mdslideshow/slideshow';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-redtext-page',
  templateUrl: './redtext-page.component.html',
  styleUrls: ['./redtext-page.component.scss'],
  standalone: false,
})
export class RedtextPageComponent implements OnInit, OnDestroy {
  private initialUrl: string;

  subs = new SubSink();

  selectedRedtext$ = this.detailsStore.selectedRedtext$.pipe(
    tap((x) => {
      this.selectedRedtext = x;
    })
  );
  selectedRedtext = null;
  title = null;
  constructor(
    public detailsStore: RedtextStoreService,
    private activatedRoute: ActivatedRoute,
    private redtextPageService: RedtextPageService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private flimmoMetaService: FlimmoMetaService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    this.initialUrl = this.router.url;
    this.subs.sink = this.activatedRoute.paramMap.subscribe((value) => {
      const id = value.get('id');
      const title = value.get('title');
      this.title = title;
      if (
        (id && !title) ||
        this.selectedRedtext === null ||
        this.selectedRedtext.id !== id
      ) {
        if (id === '0') {
          this.detailsStore.selectedRedtext = null;
        }
        this.redtextPageService.getRedtext(id, (data: Redtext) => {
          if (data.published == false) this.flimmoMetaService.addNoIndex();
          if (data.title)
            this.flimmoMetaService.setFlimmoTitle(
              data.title != null
                ? data.rubrik.name + ': ' + data.title
                : data.rubrik.name
            );
          if (data.summary) this.flimmoMetaService.setDescription(data.summary);
          this.flimmoMetaService.setOG('/redtext/' + data.id, data.image);
          const prettyTitle = this.flimmoMetaService.prettifyUrl(data.title);
          if (this.title !== prettyTitle && data.title) {
            this.router.navigate(['redtext', (data.published == false) ? data.id+1000000 : data.id, prettyTitle], {
              replaceUrl: true,
            });
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.detailsStore.selectedRedtext = null;
    this.subs.unsubscribe();
    this.flimmoMetaService.removeNoIndex();
    this.resizeSubscription$?.unsubscribe();
  }

  // TODO:jk resizeobservable obsolet?
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.resizeObservable$ = fromEvent(window, 'resize');
      this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
        onResizeSlideshows(this.document);
      });
    }
  }
}
